import { RecordSelectAsyncTemplateOptions } from "./types";
import { IRecordRepeaterTemplateOptions } from "./types/repeater/controller";

export const vsName = "fieldConfigurationHelperService";

export class FieldConfigurationHelperService {
  static $inject = [];

  selectAsyncField(
    config: RecordSelectAsyncTemplateOptions
  ): AngularFormly.IFieldConfigurationObject {
    return {
      key: config.key,
      name: config.name ?? config.key,
      type: "recordSelectAsync",
      templateOptions: config,
      model: config.model,
      expressionProperties: config.expressionProperties,
      watcher: config.watcher,
      className: config.className,
    };
  }

  gridSelectAsyncField(
    config: RecordSelectAsyncTemplateOptions
  ): AngularFormly.IFieldConfigurationObject {
    return {
      key: config.key,
      name: config.name ?? config.key,
      type: "recordGridSelectAsync",
      templateOptions: config,
      model: config.model,
      expressionProperties: config.expressionProperties,
      watcher: config.watcher,
      className: config.className,
    };
  }

  repeaterField(
    config: IRecordRepeaterTemplateOptions
  ): AngularFormly.IFieldConfigurationObject {
    return {
      key: config.key,
      name: config.name ?? config.key,
      type: "recordRepeater",
      id: config.name ?? config.key,
      templateOptions: config,
    };
  }
}

// {
//   key: "MealLogReasonId",
//   name: "MealLogReasonId",
//   type: "selectAsync",
//   templateOptions: {
//     label: "Reason",
//     required: true,
//     query: [CommonMachineServerName, function (CommonMachineServer) {
//       return function (search) {
//         return CommonMachineServer.mealLogReasonsQuery({
//           NameContains: search,
//           Skip: 0,
//           Take: 25,
//           OrderBy: 'Name'
//         })
//       }
//     }],
//     getDefaultItem: function (model) {
//       return {
//         Id: model.MealLogReasonId,
//         Name: model.MealLogReasonName
//       }
//     }
//   }
